import { render, staticRenderFns } from "./PaintPopover.vue?vue&type=template&id=2818923c&scoped=true&"
import script from "./PaintPopover.vue?vue&type=script&lang=js&"
export * from "./PaintPopover.vue?vue&type=script&lang=js&"
import style0 from "./PaintPopover.vue?vue&type=style&index=0&id=2818923c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2818923c",
  null
  
)

export default component.exports